import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

function dm_c_08_latest_insights_scrolling() {
    const sections = document.querySelectorAll('.c-08-latest-insights-scrolling');

    sections.forEach((section) => {
        const slider = section.querySelector('.articles-swiper');
        const links = Array.from(section.querySelectorAll('.links li'));

        if (!slider) {
            return;
        }

        const setActiveLink = (activeIndex) => {
            links.forEach((item, index) => {
                const isActive = index === activeIndex;
                const control = item.querySelector('.insight-selector, a');

                item.classList.toggle('active', isActive);
                if (control) {
                    control.setAttribute('aria-current', isActive ? 'true' : 'false');
                }
            });
        };

        const swiper = new Swiper(slider, {
            modules: [Autoplay, EffectFade],
            effect: 'fade',
            // The legacy News embed uses Swiper's own fade opacity. Crossfade
            // keeps every non-active article transparent instead of stacking.
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            loop: true,
            autoHeight: true,
            speed: 320,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            on: {
                init(instance) {
                    setActiveLink(instance.realIndex);
                    instance.update();
                },
                slideChangeTransitionStart(instance) {
                    setActiveLink(instance.realIndex);
                }
            },
            observer: true,
            observeParents: true
        });

        links.forEach((item, index) => {
            const control = item.querySelector('.insight-selector, a');

            if (!control) {
                return;
            }

            control.addEventListener('click', (event) => {
                event.preventDefault();
                swiper.slideToLoop(index);
            });
        });

        section.addEventListener('focusin', () => {
            if (swiper.autoplay) {
                swiper.autoplay.pause();
            }
        });

        section.addEventListener('focusout', (event) => {
            if (
                swiper.autoplay &&
                (!event.relatedTarget || !section.contains(event.relatedTarget))
            ) {
                swiper.autoplay.resume();
            }
        });

        requestAnimationFrame(() => swiper.update());
        window.addEventListener('load', () => swiper.update(), { once: true });

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => swiper.update());
        }
    });
}

export { dm_c_08_latest_insights_scrolling };
